import { render, staticRenderFns } from "./OptionCards.vue?vue&type=template&id=8c576eee&scoped=true"
import script from "./OptionCards.vue?vue&type=script&lang=js"
export * from "./OptionCards.vue?vue&type=script&lang=js"
import style0 from "./OptionCards.vue?vue&type=style&index=0&id=8c576eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c576eee",
  null
  
)

export default component.exports